import React, { useRef, useState } from "react";
import Style from "./NewPayReqTabel.module.scss";
import { Button, Input, Space, Table } from "antd";
import { SearchOutlined,CopyOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Check2, PencilSquare, Wallet, XLg } from "react-bootstrap-icons";
import { succToast } from "../../../../Utils/Toast/Toast";

const NewPayReqTabel = ({ showAddress, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    
    {
      title: "آیدی درخواست ",
      dataIndex: "key",
      key: "key",
      width: "10%",
      sorter: (a, b) => a.age - b.age,
    },
    {
      title: "آیدی کاربر",
      dataIndex: "userId",
      key: "userId",
      width: "10%",
      ...getColumnSearchProps("userId", "آیدی "),
    },
    {
      title: "نام",
      dataIndex: "name",
      key: "name",
      width: "16%",
      ...getColumnSearchProps("name", "نام "),
      render: (text, record) => (
        <p style={{ cursor: "pointer" }} onClick={() => showAddress(3, record)}>
          {text}
        </p>
      ),
    },
    {
      title: "شماره شبا",
      dataIndex: "iban",
      key: "iban",
      width: "16%",
      ...getColumnSearchProps("iban", "شبا "),
      render: (text, record) => (
        <p style={{ cursor: "pointer" }} onClick={() => {
          navigator.clipboard.writeText(record.iban)
          succToast('کپی شد!')
        }}>
          {text} <CopyOutlined />
        </p>
      ),
    },
    {
      title: "شماره تلفن",
      dataIndex: "phone",
      key: "phone",
      width: "10%",
      ...getColumnSearchProps("phone", "شماره تلفن"),
    },
    {
      title: "زمان درخواست",
      dataIndex: "date",
      key: "date",
      width: "14%",
    },
    {
      title: "مبلغ درخواست",
      dataIndex: "money",
      key: "money",
      width: "10%",
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      width: "10%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => showAddress( record)}
            className={Style.editBtn}
          >
            پرداخت
            <PencilSquare />
          </button>
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ pageSize: 100 }}
        columns={columns}
        dataSource={data}
        responsive={true}
        scroll={{x:1100, y: 300 }}
      />
    </div>
  );
};

export default NewPayReqTabel;
